module.exports = __webpack_public_path__ + "media/images/icon__info--rb-gray@2x-2895daf7ec415ca16b0d92284c6a485d.png";